import { render, staticRenderFns } from "./agogis-lecturer-assignment-status-lookup.vue?vue&type=template&id=9640c9a4"
import script from "./agogis-lecturer-assignment-status-lookup.vue?vue&type=script&lang=ts"
export * from "./agogis-lecturer-assignment-status-lookup.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports